import * as Sentry from "@sentry/react";

export const trackEvent = (eventName: string, payload: Record<string, string>): void => {
  const { analyticsKit } = window;

  if (!analyticsKit) {
    Sentry.captureMessage("Attempted to capture event via analyticsKit, but no analyticsKit was found!");
    return;
  }

  try {
    analyticsKit.trackEvent(eventName, payload);
  } catch (e) {
    Sentry.captureException(e, { extra: { eventName } });
  }
};
